import { Amplify } from "aws-amplify";
import "react-app-polyfill/ie11"; // For IE 11 support
import "react-app-polyfill/stable";
import ReactDOM from "react-dom";
import AuthenticatedApp from "./AuthenticatedApp";
import "./polyfill";
import * as serviceWorker from "./serviceWorker";

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID!,
      userPoolClientId: process.env.REACT_APP_COGNITO_WEB_CLIENT_ID!,
    },
  },
});

ReactDOM.render(<AuthenticatedApp />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
